export const SENDING_BEHAVIOR_OPTIONS = [
  {
    value: 'SEND_AUTOMATICALLY',
    label: 'Enviar automaticamente'
  },
  {
    value: 'QUEUE_AS_DRAFT',
    label: 'Enfileirar envio como rascunho'
  },
  {
    value: 'DO_NOT_SEND',
    label: 'Não enviar'
  }
];
